/**
 * Pages with target "_blank" open externally and must not be
 * preloaded, transplanted, or runtime-cached by the PEP shell.
 */
export function isExternalBlankTarget(item) {
  return Boolean(item && item.target === '_blank');
}

export function getEmbeddablePages(navigation) {
  return Object.fromEntries(
    Object.entries(navigation || {}).filter(([, item]) => !isExternalBlankTarget(item))
  );
}

/** How many non-home pages to warm in parallel after the shell is ready. */
export const BACKGROUND_WARM_CONCURRENCY = 2;

/**
 * Pages that must finish before the shell is shown.
 * Home only — keeps first paint fast while still warming the main ticket page.
 */
export function getCriticalStartupPages(navigation) {
  const embeddable = getEmbeddablePages(navigation);
  if (!embeddable.home) {
    return {};
  }
  return { home: embeddable.home };
}

/**
 * Embeddable pages warmed after init (menu + shortcuts), excluding home.
 */
export function getBackgroundWarmPages(navigation) {
  const embeddable = getEmbeddablePages(navigation);
  return Object.fromEntries(
    Object.entries(embeddable).filter(([name]) => name !== 'home')
  );
}

/**
 * Next keys to start warming given pending queue and in-flight count.
 */
export function nextBackgroundWarmKeys(
  pendingKeys,
  activeCount,
  concurrency = BACKGROUND_WARM_CONCURRENCY
) {
  const slots = Math.max(0, concurrency - activeCount);
  return (pendingKeys || []).slice(0, slots);
}
